import { msg } from "../locales/translate";
import { GD } from "src/GD";
import { getNotificationErrorMessage, notify } from "./notify";

export const forceSessionWebhook = async (sessionId: number) => {
	try {
		const response = await GD.REQ_API.request({
			method: "gate/force/webhook",
			data: {
				session_id: sessionId,
			},
		});

		if (response?.error) {
			notify.error(getNotificationErrorMessage(response.error, msg("unableToForceWebhook")));
		}

		return response;
	} catch (error) {
		notify.error(getNotificationErrorMessage(error, msg("unableToForceWebhook")));
	}
};